var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    { class: _vm.$style.mobileNav },
    [
      _c("CategoryMenuToolbar", {
        class: _vm.$style.mobileMenu,
        attrs: {
          activeCategoryName: _vm.activeCategory.title,
          menu: _vm.shownMenuItems,
        },
        on: { itemClick: _vm.navigate, menuControlClick: _vm.toggleDrawer },
      }),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          class: [_vm.$style.slideoutMenu, _vm.$style.drawer],
          attrs: { isActive: _vm.drawerIsActive },
        },
        [
          _c("div", { class: _vm.$style.header }, [
            _c("h2", [_vm._v("Menu")]),
            _vm._v(" "),
            _c(
              "button",
              {
                class: _vm.$style.rightCta,
                on: {
                  click: function ($event) {
                    return _vm.toggleDrawer(false)
                  },
                },
              },
              [
                _c("IconOfType", {
                  class: _vm.$style.icon,
                  attrs: { name: "mdi-close" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.body },
            [
              _c("UserCredits", { class: _vm.$style.bodyHeader }),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("List", {
                class: _vm.$style.itemGroup,
                attrs: { keyName: "name", list: _vm.hiddenMenuItems },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "button",
                          {
                            class: [_vm.$style.item, _vm.$style.menuItem],
                            on: {
                              click: function ($event) {
                                return _vm.selectMenuItem(item)
                              },
                            },
                          },
                          [
                            _c("IconOfType", {
                              class: _vm.$style.icon,
                              attrs: { name: item.icon },
                            }),
                            _vm._v(" "),
                            _c("span", { class: _vm.$style.label }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                            _vm._v(" "),
                            _c("IconOfType", {
                              class: _vm.$style.icon,
                              attrs: { name: "mdi-chevron-right" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "Drawer",
        {
          class: _vm.$style.drawer,
          attrs: { isActive: _vm.subDrawerIsActive },
        },
        [
          _c("div", { class: _vm.$style.header }, [
            _c(
              "button",
              {
                class: [_vm.$style.back, _vm.$style.leftCta],
                on: {
                  click: function ($event) {
                    _vm.subDrawerIsActive = false
                  },
                },
              },
              [
                _c("IconOfType", {
                  class: _vm.$style.icon,
                  attrs: { name: "mdi-chevron-left" },
                }),
                _vm._v("\n        Back\n      "),
              ],
              1
            ),
            _vm._v(" "),
            _c("h3", [_vm._v(_vm._s(_vm.activeCategory.title))]),
            _vm._v(" "),
            _c(
              "button",
              {
                class: _vm.$style.rightCta,
                on: {
                  click: function ($event) {
                    return _vm.toggleDrawer(false)
                  },
                },
              },
              [
                _c("IconOfType", {
                  class: _vm.$style.icon,
                  attrs: { name: "mdi-close" },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { class: _vm.$style.body },
            [
              _c("List", {
                class: _vm.$style.itemGroup,
                attrs: { list: _vm.activeSubmenu },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("CategorySubmenuItem", {
                          class: _vm.$style.item,
                          attrs: { item: item },
                          on: { itemClick: _vm.navigate },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }